
import { Box, Typography } from '@mui/material'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-premium'
import { Link } from 'react-router-dom'
import { DensityStyleTypes } from '../../../../types'

interface AffiliatedCellProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  densityStyles: DensityStyleTypes
}

const AffiliatedCell: React.FC<AffiliatedCellProps> = ({ params, densityStyles }) => {
  const affiliated = params?.row?.affiliated ?? []
  // Entries can be null or a bare uuid string when the row was hydrated from
  // the raw record, so link to the first entry we can actually resolve.
  const linkTarget = (Array.isArray(affiliated) ? affiliated : []).find(
    (org: { PK?: string; org_uuid?: string } | null) => org?.PK || org?.org_uuid
  )
  const affiliatedPK = linkTarget?.PK || `ORG_${linkTarget?.org_uuid}`
  // return affiliated && affiliated?.org_uuid ? (
  // if (!params?.row?.isParent) return <ChildNoValueCell densityStyles={densityStyles} />
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return linkTarget ? (
    <Link
      to={`/organizations/${affiliatedPK}/details`}
      style={{
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'left',
          alignItems: 'center',
          height: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          padding: densityStyles.padding,
          gap: densityStyles.gap,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'left', overflow: 'hidden', textOverflow: 'ellipsis', gap: 1 }}>
          <Typography
            sx={{
              fontSize: densityStyles.fontSize,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
              color: params?.value ? 'text.primary' : 'text.disabled',
            }}
          >
            {params?.value ?? '—'}
          </Typography>
        </Box>
      </Box>
    </Link>
  ) : (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        textAlign: 'left',
        height: '100%',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: 'text.disabled',
      }}
    >
      {'—'}
    </Box>
  )
}
export default AffiliatedCell
